// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Feeds/components/index.css
// module id = 897
// module chunks = 0